import { getWindowWidth, getWindowHeight } from '@/Utils/WindowUtility.js';
import { getHorizontalPosition, getVerticalPosition } from '@/Utils/BoundaryUtility.js';
import { setStyles } from '@/Utils/StylesUtility.js';

export default {
    methods: {
        setTooltipPosition() {
            const winHeight = getWindowHeight();
            const winWidth = getWindowWidth();
            const triggerElement = this.$refs.trigger;
            const contentElement = this.$refs.content;

            if (contentElement && triggerElement) {
                const triggerBounding = triggerElement.getBoundingClientRect();
                const contentBounding = contentElement.getBoundingClientRect();
                const verticalPosition = getVerticalPosition(winHeight, triggerBounding, contentBounding, this.verticalPosition);
                const horizontalPosition = getHorizontalPosition(winWidth, triggerBounding, contentBounding, this.position);
                this.direction = verticalPosition.direction;
                this.anchor = horizontalPosition.anchor;

                this.$emit('position-update', this.direction, this.anchor);

                this.$nextTick(() => {
                    const style = { ...verticalPosition.style, ...horizontalPosition.style };
                    setStyles(contentElement, style);
                });
            }
        },
    },
};